import { render, staticRenderFns } from "./auction-search-item.vue?vue&type=template&id=22ec6d6b&"
import script from "./auction-search-item.vue?vue&type=script&lang=js&"
export * from "./auction-search-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports